export default "__VITE_ASSET__PL_gZOdW__"